import React, { useState, useCallback, useMemo } from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Modal, Radio, Input, message } from 'antd';
import { FormComponentProps } from '@ant-design/compatible/lib/form/Form';
import { IParameterList } from '../type';

import style from './index.less';

type Prop = {
  /** 是否显示 */
  visible?: boolean;
  /** 关闭的回调 */
  onClose?: React.MouseEventHandler<HTMLElement>;
  /** 所有的保存好了的查询参数的列表,用于判断是否重复 */
  parameterList?: IParameterList[];
  /** 当前选中的查询参数id */
  parameterId?: string | number;
  /** 选择替换某个查询条件的回调 */
  onEditParameter(selected: number): Promise<Record<string, unknown>>;
  /** 点击添加新的查询参数的回调 */
  onAddParameter(name: string): Promise<Record<string, unknown>>;
};

const SaveParamsModal: React.FC<Prop & FormComponentProps> = ({
  visible = true,
  onClose = () => null,
  parameterList = [],
  parameterId = 0,
  onAddParameter,
  onEditParameter,
  form
}) => {
  const { getFieldDecorator } = form;
  const [selected, setSelected] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);

  const radioChange = useCallback(e => {
    const { target } = e;
    setSelected(target.value);
  }, []);

  const addParams = (name: string) => {
    setLoading(true);
    onAddParameter(name).finally(() => setLoading(false));
  };

  const onOk = () => {
    // 如果选中的不是0
    if (selected !== 0) {
      setLoading(true);
      onEditParameter(selected).finally(() => setLoading(false));
      return;
    }
    form.validateFields((error, value) => {
      if (!error) {
        if (parameterList && parameterList.find(item => item.name === value.name)) {
          message.error('请输入不同的名称');
          return;
        }
        addParams(value.name);
      }
    });
  };

  const afterClose = useCallback(() => {
    form.resetFields();
    setSelected(0);
  }, []);

  let hideCreate = true;

  const currentParameter: IParameterList | undefined | null = useMemo(() => {
    if (parameterList && Array.isArray(parameterList)) {
      return parameterList.find(item => item.id === parameterId);
    }
    return null;
  }, [parameterList, parameterId]);

  if (currentParameter && selected === 0) {
    hideCreate = false;
  }
  if (Array.isArray(parameterList) && !parameterList.length) {
    hideCreate = false;
  }
  if (parameterId === 0 || parameterId === 'defaultId') {
    hideCreate = false;
  }

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      width={346}
      title={'保存为常用筛选'}
      cancelText={'取消'}
      okText={'确定'}
      onOk={onOk}
      afterClose={afterClose}
      okButtonProps={{
        loading
      }}>
      <Radio.Group className={style.content} value={selected} onChange={radioChange}>
        <div>
          <Radio value={0}>{'新建常用筛选项'}</Radio>
        </div>
        <div className={style.label_margin}>
          <Form hideRequiredMark>
            <Form.Item label="">
              {getFieldDecorator('name', {
                rules: [{ required: true, message: '请输入筛选项名称' }]
              })(<Input disabled={hideCreate} maxLength={20} />)}
            </Form.Item>
          </Form>
        </div>
        {parameterId && Array.isArray(parameterList) && parameterList.length && currentParameter ? (
          <div>
            <Radio value={currentParameter.id}>{'更新当前常用筛选项'}</Radio>
            <div className={`${style.label_margin} ${style.name}`}>{currentParameter.name}</div>
          </div>
        ) : null}
      </Radio.Group>
    </Modal>
  );
};

export default Form.create<Prop & FormComponentProps>({ name: 'saveParamsModal' })(SaveParamsModal);
